import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import '@/styles/Title.css';
/**
 * Title component that displays the main title of the application.
 *
 * @returns {JSX.Element} The Title component.
 */
const Title = () => (_jsx("div", Object.assign({ className: "title-container" }, { children: _jsx("h1", { children: "PRODUCT LEARNING AI CHATBOT" }) })));
export default Title;
